import {
  SET_BID_STAGING,
  MARK_STAGING_LOADING,
  SET_VALIDATION,
  UPDATE_STAGING_EQUIP,
  SET_STAGING_FIELDS,
} from './actiontypes';
import {
  uploadStagingCsv,
  getBuildingStaging,
  getBuildingStagingCsv,
  promoteStagingEquipment,
  validateStaging,
  getEquipmentStaging,
  postStagingJson,
  getStagingFieldGroups,
} from '../../api/Api';
import fetchBuildingsActionCreator, { invalidateBuildingsAction } from './buildings';
import { downloadBlob } from '../../utils/downloads';

export const downloadStagingCsvAction =
  (buildingId, params = {}) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
    } = getState();
    let filename = `equip-staging_building-${buildingId}`;
    if (params.cardinality) filename = `${filename}-${params.cardinality}`;
    return getBuildingStagingCsv(jwt, buildingId, params).then((blob) =>
      downloadBlob(blob, `${filename}.csv`)
    );
  };

const setStaging = (dispatch, buildingId, { equipment, points_by_equip_id: points }) =>
  dispatch({
    type: SET_BID_STAGING,
    buildingId,
    equipment,
    points,
  });

const updateStaging = (dispatch, buildingId, { equipment, points_by_equip_id: points }) =>
  dispatch({
    type: UPDATE_STAGING_EQUIP,
    buildingId,
    equipment,
    points,
  });

export const validateStagingAction = (buildingId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return validateStaging(jwt, buildingId)
    .then((data) => {
      const { equipment, points } = data;
      dispatch({ type: SET_VALIDATION, buildingId, equipment, points, buildingError: {} });
      return data;
    })
    .catch((buildingError) => {
      dispatch({ type: SET_VALIDATION, buildingId, buildingError });
    });
};

export const fetchStagingAction = (buildingId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  dispatch({ type: MARK_STAGING_LOADING, buildingId });
  return getBuildingStaging(jwt, buildingId)
    .then((data) => setStaging(dispatch, buildingId, data))
    .then(() => dispatch(validateStagingAction(buildingId)));
};

export const fetchStagingFieldsAction = (buildingId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getStagingFieldGroups(jwt, buildingId).then((data) =>
    dispatch({
      type: SET_STAGING_FIELDS,
      buildingId,
      data,
    })
  );
};

export const uploadStagingCsvAction = (buildingId, file) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return uploadStagingCsv(buildingId)(file, jwt).then((data) => {
    dispatch(fetchStagingAction(buildingId));
    return data;
  });
};

export const promoteEquipsTopicsAction =
  (buildingId, equips, topics, deletes) => (dispatch, getState) => {
    const {
      user: { jwt },
    } = getState();
    return promoteStagingEquipment(jwt, buildingId, equips, topics, deletes).then((data) => {
      dispatch(fetchStagingAction(buildingId));
      dispatch(invalidateBuildingsAction());
      const { equipment, points } = data;
      dispatch({ type: SET_VALIDATION, buildingId, equipment, points });
      return dispatch(fetchBuildingsActionCreator()).then(() => data);
    });
  };

export const promoteAllAction = (buildingId, deletes) => (dispatch) =>
  dispatch(promoteEquipsTopicsAction(buildingId, [], [], deletes));

export const getEquipmentDetailsAction = (buildingId, equipIds) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const promises = equipIds.map((equipId) =>
    getEquipmentStaging(jwt, buildingId, equipId).then((result) => {
      // This works except in cases where an equipment is being pushed out entirely. In that case, we need to explicitly invalidate the existing entry
      if (!(equipId in result.points_by_equip_id))
        // eslint-disable-next-line no-param-reassign
        result.points_by_equip_id[equipId] = [];
      return result;
    })
  );
  return Promise.all(promises)
    .then((results) => {
      const merged = results.shift();
      results.forEach((result) => {
        merged.equipment = merged.equipment.concat(result.equipment);
        Object.assign(merged.points_by_equip_id, result.points_by_equip_id);
      });
      return merged;
    })
    .then((update) => updateStaging(dispatch, buildingId, update));
};

/**
 * Update a staging equipment or point. There is a gap if you attempt to change an equipId since we won't update the old equip id
 */
export const updateStagingEquipment = (buildingId, equipIds, data) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return postStagingJson(jwt, buildingId, data).then((r) => {
    dispatch(getEquipmentDetailsAction(buildingId, equipIds));
    dispatch(validateStagingAction(buildingId, true));
    return r;
  });
};
